export interface CMSAction {
  type: "switch_record";
  datasetId: string;
  recordIndex: number;
  datasetName?: string;
}

export interface ActionableComponent {
  id: string;
  cmsAction?: CMSAction;
}

export class CMSActionService {
  /**
   * Create a CMS record switch action
   */
  static createSwitchRecordAction(
    datasetId: string,
    recordIndex: number,
    datasetName?: string,
  ): CMSAction {
    return {
      type: "switch_record",
      datasetId,
      recordIndex,
      datasetName,
    };
  }

  /**
   * Execute a CMS action
   */
  static executeCMSAction(
    action: CMSAction,
    setActiveCMSRecord: (datasetId: string, recordIndex: number) => void,
  ): void {
    console.log("⚡ CMSActionService.executeCMSAction called:", action);

    switch (action.type) {
      case "switch_record":
        console.log("🔄 Switching CMS record:", {
          datasetId: action.datasetId,
          recordIndex: action.recordIndex,
          datasetName: action.datasetName,
        });
        setActiveCMSRecord(action.datasetId, action.recordIndex);
        console.log("✅ CMS record switch completed");
        break;
      default:
        console.warn("❌ Unknown CMS action type:", action.type);
    }
  }

  /**
   * Get action description for UI display
   */
  static getActionDescription(action: CMSAction): string {
    switch (action.type) {
      case "switch_record": {
        const datasetName = action.datasetName || "Dataset";
        return `Switch to record ${action.recordIndex + 1} in ${datasetName}`;
      }
      default:
        return "Unknown action";
    }
  }

  /**
   * Check if component has CMS action
   */
  static hasAction(component: ActionableComponent): boolean {
    return !!component.cmsAction;
  }

  /**
   * Remove CMS action from component
   */
  static removeAction(component: ActionableComponent): Partial<ActionableComponent> {
    const { cmsAction, ...rest } = component;
    return rest;
  }
}
